import { Button, Flex, InputItem, Modal, Toast } from 'antd-mobile'
import React, { useEffect, useState } from 'react'
import { addCustomForm } from '../../../api/data'
import { getCustomFormTemplates } from '../../../api/visit'
import modStyl from './index.module.scss'

type Props = {
  visitId: number
  onClose: () => void
}

const CreateFormModal: React.FC<Props> = ({ visitId, onClose })=> {

  const [loading, setLoading] = useState(false)
  const [name, setName] = useState('')
  const [templateId, setTemplateId] = useState(8)

  const [templates, setTemplates] = useState<{
    value: number;
    label: string;
  }[]>([])

  const onConfirm = async ()=> {
    if (name.length === 0) {
      Toast.show('请输入表单名称')
      return
    }
    setLoading(true)
    const {code, message} = await addCustomForm({
      visitId,
      name,
      templateId,
    })
    setLoading(false)
    if(code === 0) {
      onClose()
      Toast.success('添加成功')
    }
  }

  const fetchTemplates = async ()=> {
    const { code, data } = await getCustomFormTemplates(visitId)
    if(code === 0) {
      if(data.length === 1) {
        setTemplateId(data[0].id)
      }
      setTemplates(data.map(({id, name})=> ({value: id, label: name})))
    }
  }

  useEffect(()=> {
    fetchTemplates()
  }, [])

  return (
    <Modal
      visible
      popup
      closable
      transparent
      maskClosable
      onClose={onClose}
      animationType="slide-up"
      title="新增表单">
      <Flex direction="column">
        <Flex.Item style={{ width: "100%" }}>
          <InputItem onChange={(value)=> setName(value)} placeholder='请输入表单名称' className={modStyl.itemWrapper}/>
        </Flex.Item>
        <Flex.Item style={{ width: "100%", marginTop: 10 }}>
          <Flex>
            <Flex.Item flex={1} style={{ paddingRight: 10 }}>
              <Button onClick={onClose}>取消</Button>
            </Flex.Item>
            <Flex.Item flex={1} style={{ paddingLeft: 10 }}>
              <Button loading={loading} onClick={onConfirm} type="primary">确定</Button>
            </Flex.Item>
          </Flex>
        </Flex.Item>
      </Flex>
    </Modal>
  )
}

export default CreateFormModal